var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import { Component } from 'react';
import qs from 'query-string';
import PropTypes from 'prop-types';
import { historyShape, locationShape } from 'tss-core-lib-common';

var WithFilter = function (_Component) {
  _inherits(WithFilter, _Component);

  function WithFilter(props) {
    _classCallCheck(this, WithFilter);

    var _this = _possibleConstructorReturn(this, (WithFilter.__proto__ || Object.getPrototypeOf(WithFilter)).call(this, props));

    _this.postOptions = function (newOptions) {
      if (!_this.props.dynamicPageNr) {
        return Object.assign({
          pageNr: 1
        }, newOptions);
      }
      return newOptions;
    };

    _this.handleFilterChange = function (id, value) {
      // Update URL to reflect filter change
      var options = _this.getOptions(_this.props);
      if (Array.isArray(options[id])) {
        if (options[id].indexOf(value.toString()) === -1) {
          options[id].push(value);
        } else {
          // Value already selected
          return;
        }
      } else if (value.toString() !== options[id] && typeof options[id] !== 'undefined') {
        options[id] = [options[id], value];
      } else if (value.toString() === options[id]) {
        // Value already selected
        return;
      } else {
        options[id] = value;
      }

      if (_this.props.postProcessOptions) {
        options = _this.props.postProcessOptions(options);
      }

      _this.props.history.replace({
        pathname: _this.props.location.pathname,
        search: qs.stringify(_this.postOptions(options)),
        state: Object.assign({}, _this.props.location.state || {}, {
          reset: true
        })
      });
    };

    _this.handleSearchQueryChange = function (searchQuery) {
      // Update URL to reflect search query change
      _this.setState({ searchQuery: searchQuery });
      clearTimeout(_this.timer);

      _this.timer = setTimeout(function () {
        _this.props.history.replace({
          pathname: _this.props.location.pathname,
          search: qs.stringify(Object.assign({}, qs.parse(_this.props.location.search), {
            searchQuery: searchQuery
          })),
          state: Object.assign({}, _this.props.location.state || {}, {
            reset: true
          })
        });
      }, 500);
    };

    _this.handleCloseFilterValueClick = function (id, value) {
      // Update URL to reflect filter change
      var options = qs.parse(_this.props.location.search);
      if (Array.isArray(options[id])) {
        var index = options[id].indexOf(value.toString());
        if (index >= 0) {
          options[id].splice(index, 1);
        }
      } else {
        delete options[id];
      }

      if (_this.props.postProcessOptions) {
        options = _this.props.postProcessOptions(options);
      }

      _this.props.history.replace({
        pathname: _this.props.location.pathname,
        search: qs.stringify(_this.postOptions(options)),
        state: Object.assign({}, _this.props.location.state || {}, {
          reset: true
        })
      });
    };

    _this.handleClearAllFiltersClick = function () {
      var options = {};

      if (_this.props.postProcessOptions) {
        options = _this.props.postProcessOptions(options);
      }

      _this.props.history.replace({
        pathname: _this.props.location.pathname,
        search: qs.stringify(options),
        state: Object.assign({}, _this.props.location.state || {}, {
          reset: true
        })
      });
    };

    _this.handleSortOrderChange = function (sortBy, sortDesc) {
      _this.props.history.replace({
        pathname: _this.props.location.pathname,
        search: qs.stringify(Object.assign({}, qs.parse(_this.props.location.search), {
          sortBy: sortBy,
          sortDesc: sortDesc
        })),
        state: Object.assign({}, _this.props.location.state || {}, {
          reset: true
        })
      });
    };

    _this.handlePageChange = function (pageNr) {
      _this.props.history.replace({
        pathname: _this.props.location.pathname,
        search: qs.stringify(Object.assign({}, qs.parse(_this.props.location.search), {
          pageNr: pageNr
        })),
        state: Object.assign({}, _this.props.location.state || {}, {
          reset: true
        })
      });
    };

    _this.refresh = function () {
      return _this.props.fetcher(_this.props, _this.getOptions());
    };

    var query = qs.parse(props ? props.location.search : _this.props.location.search);
    _this.state = {
      searchQuery: query.searchQuery || '',
      preventDoubleFetching: false
    };
    return _this;
  }

  _createClass(WithFilter, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var options = this.getOptions();
      if (this.props.postProcessOptions) {
        options = this.props.postProcessOptions(options);

        this.props.history.replace({
          pathname: this.props.location.pathname,
          search: qs.stringify(this.postOptions(options)),
          state: Object.assign({}, this.props.location.state || {}, {
            reset: false
          })
        });
      }

      this.props.fetcher(this.props, options);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // Always fetch loggers as a reaction to location change - do not fetch in event callbacks
      if (this.state.preventDoubleFetching) {
        if (this.props.location !== nextProps.location) {
          var options = this.getOptions(nextProps);
          if (this.props.postProcessOptions) {
            options = this.props.postProcessOptions(options);
          }
          this.props.fetcher(nextProps, options);
        }
      }
      if (!this.state.preventDoubleFetching) {
        this.setState({ preventDoubleFetching: true });
      }
    }
  }, {
    key: 'getOptions',
    value: function getOptions(props) {
      var options = Object.assign({
        sortBy: props ? props.defaultSortBy : this.props.defaultSortBy,
        sortDesc: props ? props.defaultSortDesc : this.props.defaultSortDesc
      }, qs.parse(props ? props.location.search : this.props.location.search), {
        searchQuery: this.state.searchQuery
      });

      if (Reflect.has(options, 'sortDesc')) {
        options.sortDesc = options.sortDesc === 'true' || options.sortDesc === true;
      }

      if (Reflect.has(options, 'pageNr')) {
        options.pageNr = parseInt(options.pageNr, 10);
      }

      return options;
    }
  }, {
    key: 'render',
    value: function render() {
      var options = this.getOptions(this.props);
      if (this.props.postProcessOptions) {
        options = this.props.postProcessOptions(options);
      }

      return this.props.render(options, {
        onCloseFilterValueClick: this.handleCloseFilterValueClick,
        onClearAllFiltersClick: this.handleClearAllFiltersClick,
        onSearchQueryChange: this.handleSearchQueryChange,
        onFilterChange: this.handleFilterChange,
        onSortOrderChange: this.handleSortOrderChange,
        onPageChange: this.handlePageChange
      });
    }
  }]);

  return WithFilter;
}(Component);

WithFilter.propTypes = {
  render: PropTypes.func.isRequired,
  history: historyShape.isRequired,
  location: locationShape.isRequired,
  postProcessOptions: PropTypes.func,
  fetcher: PropTypes.func.isRequired,
  defaultSortBy: PropTypes.string, // eslint-disable-line
  defaultSortDesc: PropTypes.bool, // eslint-disable-line
  dynamicPageNr: PropTypes.bool // eslint-disable-line
};
WithFilter.defaultProps = {
  defaultSortBy: null,
  defaultSortDesc: null,
  postProcessOptions: null
};


export default WithFilter;